import { graphql, HttpResponse } from 'msw'
import { type EnrollmentWelcomeIraData, type EnrollmentWelcomeIraSubmitOutput } from '../../../../../models'

export const getEnrollmentWelcomeIraDataMock: EnrollmentWelcomeIraData = {
  __typename: 'SubmitEnrollmentSuccess',
}

export const submitEnrollmentWelcomeIraDataMock: EnrollmentWelcomeIraSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/step-1',
}

export const mockGetEnrollmentWelcomeIraData = graphql.mutation('getEnrollmentWelcomeIraData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentWelcomeIraDataMock } })
})

export const mockSubmitEnrollmentWelcomeIraData = graphql.mutation('submitEnrollmentWelcomeIraData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentWelcomeIraDataMock } })
})

export const mockEnrollmentWelcomeIra = [mockGetEnrollmentWelcomeIraData, mockSubmitEnrollmentWelcomeIraData]
